import { createEntityAdapter } from '@reduxjs/toolkit';

const sellersJsonsAdapter = createEntityAdapter();

export default sellersJsonsAdapter;
